import './Style.css'; // Import the CSS file for styling
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FiMenu, FiX } from 'react-icons/fi'; // Icons for menu toggle
import logo from './assets/logo.png'; // Import the logo
import { NavLink } from 'react-router-dom';
import React, { useState, useEffect, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = () => {
    // State for menu and sidebar toggle
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sidebarRef = useRef(null); // Ref for sidebar
    const navbarLinksRef = useRef(null); // Ref for navbar links
    const toggleButtonRef = useRef(null); // Ref for toggle button

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Handle clicks outside the sidebar and navbar links
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close sidebar if click is outside
            if (isSidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsSidebarOpen(false);
            }

            // Close navbar links if click is outside (mobile mode)
            if (
                isMenuOpen &&
                navbarLinksRef.current &&
                !navbarLinksRef.current.contains(event.target) &&
                toggleButtonRef.current &&
                !toggleButtonRef.current.contains(event.target)
            ) {
                setIsMenuOpen(false);
            }
        };

        // Add event listener to document
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isSidebarOpen, isMenuOpen]); // Dependencies on both states

    return (
        <>
            <nav className="navbar">
                {/* Logo Section */}
                <div className="navbar-logo">
                    <NavLink to="/"><img src={logo} alt="Logo" className="navbar-logo-img" /></NavLink>
                </div>

                {/* Menu Toggle Button for Mobile */}
                <button
                    className="navbar-toggle"
                    onClick={toggleMenu}
                    aria-label="Toggle navigation menu"
                    ref={toggleButtonRef}
                >
                    {isMenuOpen ? <FiX /> : <FiMenu />}
                </button>

                {/* Navigation Links */}
                <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`} ref={navbarLinksRef}>
                    <li><NavLink to="/" activeClassName="active">Home</NavLink></li>
                    <li><NavLink to="/about" activeClassName="active">About</NavLink></li>
                    <li><NavLink to="/services" activeClassName="active">Services</NavLink></li>
                    <li><NavLink to="/portfolio" activeClassName="active">Portfolio</NavLink></li>
                    <li><NavLink to="/blog" activeClassName="active">Blog</NavLink></li>
                    <li><NavLink to="/contact" activeClassName="active">Contact</NavLink></li>
                </ul>

                {/* 9-Dot Button for Sidebar */}
                <button className="navbar-dots" onClick={toggleSidebar}>
                    <div className="nine-dots">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                    </div>
                </button>
            </nav>

            {/* Sidebar */}
            <div className={`sidebar ${isSidebarOpen ? 'active' : ''}`} ref={sidebarRef}>
                <div className="sidebar-content">
                    <div className='row'>
                        <div className='col-8'>
                            <img src={logo} alt="Logo" className="sidebar-logo" style={{ marginRight: '0%' }} />
                        </div>
                        <div className='col-4'>
                            {/* Close Button */}
                            <button className="sidebar-close" onClick={toggleSidebar} style={{ marginLeft: '0%' }}>
                                X
                            </button>
                        </div>
                        <div className='col-2'>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 mt-5'>
                            <h3>About Us</h3>
                            <p className='mt-3'>We’re partner-centric problem solvers who focus on each and every aspect of your user journey to help your business grow. Being 'partner-centric' means that we consider your business as our own and make sure that it reaches the heights that you expect it to grow. Furthermore, we consider ourselves high-level executors. We make sure all your ideas are planned and executed through our social media, paid & website channels in an efficient manner due to which clients love us.</p>
                            <NavLink to="/contact" activeClassName="active"><button className="sidebar-contact mt-5">Contact Us</button></NavLink>
                        </div>
                    </div>

                    <a href="/some-link" className="sidebar-button mt-5">Go to Link</a>

                    {/* Social Media Icons */}
                    <div className="navbar-icons">
                        <a href="https://www.facebook.com/DotLocalHost/" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;